<template>
  <div class="block-today-word">
    <transition name="result">
      <div class="question-block" v-if="!this.fortuneResult">
        <img class="title-img" :class="{hide: isLoading}" src="/static/img/recommend/lp/houen/products/today_word/title_todayword.png" alt="">
        <div class="btn-area">
          <div class="words">
            <p>毎日ちょっとだけ気分良く過ごせる<br>ひとことをつぶやきます！</p>
            <p class="attention">\あなたの暴露数をタップしてね/</p>
          </div>
          <span
            class="item-btn"
            v-for="(item, idx) in logicList"
            :key="idx"
            @click="onNumBtnClick(idx, item)"
          >{{idx + 1}}</span>
        </div>
      </div>
    </transition>

    <transition name="result">
      <div class="result-block" v-if="this.fortuneResult">
        <img class="title-img" :class="{hide: isLoading}" src="/static/img/recommend/lp/houen/products/today_word/title_todayword.png" alt="">
        <p class="result-text" v-if="this.fortuneResult" v-html="this.fortuneResult.text"></p>
      </div>
    </transition>

    <transition name="loading" @after-leave="onCoverLeave">
      <div class="loading" v-if="isLoading">
        <img v-if="!isLoadError" src="/static/img/common/loading.svg" alt="">
        <p v-else class="load-error">結果の取得に失敗しました。<br>時間をおいて再度お試しください</p>
      </div>
    </transition>
  </div>
</template>


<script>
import axios from 'axios'
// import moment from 'moment'
import {mapState} from 'vuex'

const RESULT_SAVE_LSKEY = 'houen_products_index_result'

export default {
  name: 'BlockTodayWord',
  props: {
    logicList: {
      type: Array,
    }
  },
  data() {
    return {
      lock: true,
      isLoading: true,
      isLoadError: false,
      fortuneResult: null,
    }
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      userInfo: state => state.account.user,
      subscInfo: state => state.account.subscription
    }),
  },
  mounted() {
    this.checkHasResult()
  },
  methods: {
    checkHasResult() {
      const dt = JSON.parse(localStorage.getItem(RESULT_SAVE_LSKEY))
      if(dt) {
        // check expires
        if(this.$nowTime.now.isSameOrBefore(dt.expire)){
          this.fortuneResult = dt
        } else {
          this.fortuneResult = null
          localStorage.removeItem(RESULT_SAVE_LSKEY)
        }
      }
      // setTimeout(() => {
        this.isLoading = false
        this.lock = false
      // }, 5000)
    },
    onNumBtnClick(idx, logic) {
      if(!this.lock) {
        console.log('[%s]ボタン押した[logic:%s] userInfo:%O', idx, logic, this.userInfo)
        this.lock = true
        const birthStr = `${this.userInfo.profile.birthday.substring(0, 4)}-${this.userInfo.profile.birthday.substring(4, 6)}-${this.userInfo.profile.birthday.substring(6, 8)}`
        const now = this.$nowTime.now.endOf('day')
        const mtc = this.userInfo.profile.birthday.match(/(\d{4})(\d{2})(\d{2})/)
        this.isLoading = true
        if(!!mtc){
          axios.post('/api/logic/products', {
            birthday: `${mtc[1]}-${mtc[2]}-${mtc[3]}`,
            menu_id: logic
          })
            .then(res => {
              if(res.data.status.toLowerCase() === 'success') {
                this.fortuneResult = {
                  expire: now.toString(),
                  text: res.data.result.text
                }
                localStorage.setItem(RESULT_SAVE_LSKEY, JSON.stringify(this.fortuneResult))
                this.isLoading = false
              } else {
                console.error('Error:[%s] %s', res.data.error_code, res.data.error_message)
                this.isLoadError = true
                setTimeout(()=> {
                  this.isLoading = false
                }, 3000)
              }
            })
            .catch(err => {
              console.error('Error: 通信に失敗しました')
            })
        }
      }
    },
    onCoverLeave() {
      this.isLoadError = false
      this.lock = false
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

.block-today-word {
  width: 100%;
  height: 0;
  padding-top: 80.26%;
  position: relative;
  .question-block {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    background: url(/static/img/recommend/lp/houen/products/today_word/bg_todayword1.png) no-repeat center center;
    background-size: 100% auto;
    padding-top: 24.5%;
    .btn-area {
      padding: 16px 20px 20px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      height: 100%;
      @include mq('w580') {
        padding: 32px 28px 20px;
      }
      .words {
        font-size: 14px;
        line-height: 22px;
        width: 100%;
        margin-bottom: 8px;
        @include mq('w580') {
          font-size: 20px;
          line-height: 28px;
        }
        p {
          margin-bottom: 0;
          color: $col_base_black;
          &.attention {
            font-size: 15px;
            font-weight: bold;
            @include mq('w580') {
              font-size: 22px;
            }
          }
        }
      }
      .item-btn {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        color: var(--second);
        font-weight: bold;
        width: 15%;
        height: 30%;
        margin-bottom: 4px;
        user-select: none;
        cursor: pointer;
        background: url(/static/img/recommend/lp/houen/products/today_word/btn_todayword_num.svg) no-repeat center center;
        background-size: 100% auto;
      }
    }
  }
  .result-block {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 12;
    background: url(/static/img/recommend/lp/houen/products/today_word/bg_todayword2.png) no-repeat center center;
    background-size: 100% auto;
    .result-text {
      color: var(--key-color);
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      width: 47%;
      height: 32%;
      display: flex;
      align-items: center;
      margin: 35% auto auto 12%;
      @include mq('w580') {
        font-size: 20px;
        line-height: 28px;
      }
    }
  }
}

.title-img {
  width: 62%;
  position: absolute;
  top: -9%;
  left: 4%;
  opacity: 1;
  transition: all 200ms ease-out 0s;
  transform: translate(0, 0);
  &.hide {
    opacity: 0;
    transform: translate(0, 10px);
  }
}

.loading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    display: block;
    width: 24%;
    height: auto;
  }
  .load-error {
    color: red;
  }
}

.result {
  &-enter-active,
  &-leave-active {
    transition: all 300ms ease-out 0s;
  }
  &-enter, &-leave-to {
    opacity: 0;
  }
  &-enter-to, &-leave {
    opacity: 1;
  }
}

.loading {
  &-enter-active,
  &-leave-active {
    transition: all 300ms ease-out 0s;
  }
  &-enter, &-leave-to {
    opacity: 0;
  }
  &-enter-to, &-leave {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/BlockTodayWord.vue